import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { InAppBrowser } from '@capgo/inappbrowser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-promotion-popup-modal',
  templateUrl: './promotion-popup-modal.component.html',
  styleUrls: ['./promotion-popup-modal.component.scss']
})
export class PromotionPopupModalComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public promotion: any;
  public popUpImageUrl: string = '';
  public popUpDestinationUrl: string = '';
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public backButton: Subscription | any;

  constructor(
    public modalCtrl: ModalController,
    private platform: Platform,
    public navParams: NavParams
  ) {
    this.promotion = navParams.get('promotion');
    if (this.promotion) {
      this.popUpImageUrl = this.promotion.pop_up_image_url || '';
      this.popUpDestinationUrl = this.promotion.pop_up_destination_url || '';
    }
  }

  ngOnInit() {
  }

  ionViewWillLeave() {
    if (this.platform.is('android')) {
      if (this.backButton) {
        this.backButton.unsubscribe();
      }
    }
  }

  ionViewWillEnter() {
    if (this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.closePopup();
      });
    }
  }

  closePopup() {
    this.modalCtrl.dismiss();
  }

  onImageClick() {
    if (this.popUpDestinationUrl && this.popUpDestinationUrl.trim() !== '') {
      InAppBrowser.open({ url: this.popUpDestinationUrl });
    }
    this.closePopup();
  }

}

